import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { BookPublishEditRequest } from '../../requests/platform/book-publish-edit.request';
import { BookPublishEditResponse } from '../../responses/platform/book-publish-edit.response';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
  providedIn: 'root'
})
export class BookPublishEditService extends CommonService {
  constructor(private http: HttpClient) {
    super();
  }

  public getBookPublishEdit(idBookVersion: number): Observable<BookPublishEditResponse> {
    return this.http
      .get<BookPublishEditResponse>(
        environment.urlApiPlatform + `BookPublishEdit/idBookVersion/${idBookVersion}`,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  public postBookPublishEdit(request: BookPublishEditRequest): Observable<BookPublishEditResponse> {
    return this.http
      .post<BookPublishEditResponse>(
        environment.urlApiPlatform + 'BookPublishEdit',
        request,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  public PublishBook(idBookVersion: number): Observable<ReturnStruct> {
    return this.http
      .get<ReturnStruct>(
        environment.urlApiPlatform + `BookPublishEdit/BookApprove/idBookVersion/${idBookVersion}`,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  uploadVideoFile(form: FormData) {
    // pega os headers padrão do addHeaderToken
    const options = this.addHeaderToken();

    // remove Content-Type se estiver setado
    if (options && options.headers && options.headers.has('Content-Type')) {
      options.headers = options.headers.delete('Content-Type');
    }

    return this.http
      .post<any>(`${environment.urlApiPlatform}BookPublishEdit/upload-video`, form, options)
      .pipe(catchError(this.handleError));
  }
}
